import { Component, OnInit, Output, EventEmitter  } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { page }  from '../class/status';
import { menulist }  from '../class/status';

@Component({
  selector: 'app-agentbonus',
  templateUrl: './agentbonus.component.html',
  styleUrls: ['./agentbonus.component.css']
})
export class AgentbonusComponent implements OnInit {

  constructor(
    public httpClient: HttpClient,
  ){}
  menu_list:menulist = [{id:'0',name:'家族獎金列表'},{id:'1',name:'月份獎金資料'}]
  search_model:string = '';
  sort_model:string = 'desc';
  order_model:string = 'id';
  now:string = '0';
  data:any=[];
  data2:any=[];
  loading:boolean=true;
  pageobj:page = {page:0,count:6,total_count:0};
  pageobjstr:string=JSON.parse(JSON.stringify(this.pageobj))
  userinfo:any={name:'',id:'-1',pic:'',diamond:0};

  ngOnInit(): void {
    this.init_list();
  }

  init_list(){
    this.loading = true;
    const body = {page: this.pageobj.page,count:this.pageobj.count,
    search:this.search_model.trim(),
    sort:this.sort_model,
    order:this.order_model,  
    type:'all',  
    };
    this.httpClient.post<any>("/get_bonus_list.php",body).subscribe(res => {
      this.loading = false;
      if(res.status){
        this.data = res.data;
        this.pageobj.total_count = res.total_count
      }else{
        this.pageobj.total_count = 0
        this.data = [];
      }
      this.pageobjstr=JSON.parse(JSON.stringify(this.pageobj))
    });
  }

  view_detail(item:any){
    this.loading = true;
    const body = {page: this.pageobj.page,count:this.pageobj.count,
    search:item,
    sort:this.sort_model,
    order:this.order_model,  
    type:'detail',  
    };
    this.httpClient.post<any>("/get_bonus_list.php",body).subscribe(res => {
      this.loading = false;
      if(res.status){
        this.data2 = res.data;
        this.pageobj.total_count = res.total_count
      }else{
        this.pageobj.total_count = 0
        this.data2 = [];
      }
      this.pageobjstr=JSON.parse(JSON.stringify(this.pageobj))
      console.log('resdetail',res);
    });
  }
  callback(pageobj:page){
    if(JSON.stringify(this.pageobj)!=JSON.stringify(pageobj)){
      this.pageobj = pageobj;
      if(this.userinfo.id == '-1'){
        this.init_list();
      }else{
        this.view_detail(this.userinfo);
      }
    }
  }

  choose(value:string){
    this.now = value;
    this.pageobj.page = 0;
    this.init_list();

  }

  select_user(item:any){
    this.userinfo.id = item.user_id;
    if(item.user_id == '-1'){
      this.choose('0')
    }else{
      this.userinfo = item;
      this.choose('1')
      this.view_detail(item)
    }
  }

}
